import React from "react";
import styled, { keyframes } from "styled-components";

const ldsRollerAnimation = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const LdsRollerContainer = styled.div`
  display: inline-block;
  position: relative;
  width: 40px;
  height: 40px;
`;

const LdsRollerDiv = styled.div`
  animation: ${ldsRollerAnimation} 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  transform-origin: 30px 30px;
  &:after {
    content: " ";
    display: block;
    position: absolute;
    width: 7px;
    height: 7px;
    border-radius: 50%;
    margin: -4px 0 0 -4px;
  }
`;

const Loader = () => {
  return (
    <LdsRollerContainer className="lds-roller">
      <LdsRollerDiv className="after:bg-main" style={{ animationDelay: "-0.036s" }} />
      <LdsRollerDiv className="after:bg-main" style={{ animationDelay: "-0.072s" }} />
      <LdsRollerDiv className="after:bg-main" style={{ animationDelay: "-0.108s" }} />
      <LdsRollerDiv className="after:bg-main" style={{ animationDelay: "-0.144s" }} />
      <LdsRollerDiv className="after:bg-main" style={{ animationDelay: "-0.18s" }} />
      <LdsRollerDiv className="after:bg-main" style={{ animationDelay: "-0.216s" }} />
      <LdsRollerDiv className="after:bg-main" style={{ animationDelay: "-0.252s" }} />
      <LdsRollerDiv className="after:bg-main" style={{ animationDelay: "-0.288s" }} />
    </LdsRollerContainer>
  );
};

export default Loader;
